export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-trial-balance': 'Imprimir balance de prueba',
    'brief': '(breve)',
    'search-about-account-number-or-name': 'Buscar número o nombre de cuenta',
    'from-account': 'De cuenta',
    'to-account': 'Hasta cuenta',
    'show-main-accounts': 'cuentas principales',
    'balanced-accounts-only': 'cuentas con saldo',
    'show-all-columns': 'mostrar sumas',
    refresh: 'buscar',
    cancel: 'Cancelar',

    'account-statement': 'Estado de cuenta',

    'sum-result-headers': {
        'debit-sum': 'Total deudor',
        'credit-sum': 'Total acreedor',
        'debit-balance': 'Saldo deudor',
        'credit-balance': 'Saldo acreedor',
    },

    'exchange-currencies-headers': {
        'difference': 'Diferencia',
        'equivalent-currency': 'Moneda equivalente',
        'currency-equivalent-balance': 'Saldo en otra moneda',
    },

    headers: {
        'account-no': 'Número de cuenta',
        'account-name': 'Nombre de cuenta',
        'parent-account': 'Cuenta principal',
        'debit-sum': 'Débito total',
        'credit-sum': 'Crédito total',
        'debit-balance': 'Saldo deudor',
        'credit-balance': 'Saldo acreedor',
    },
}